const name = 'plan';
const fragment = `fragment ${name} on UtilityPlan {
  contractTermMonths,
  customerRightsUrl,
  description,
  distributorId,
  distributorName,
  earlyTerminationFee,
  electricityFactsLabelUrl,
  estimatedMonthlyCost {
    min,
    max
  }
  greenPercentage,
  isFixedPricing,
  isGreen,
  isVariablePricing,
  legalIdentifiers {
    kind,
    identifier
  }
  name,
  nameId,
  partnerId,
  pricing {
    ... on ElectricPlanPricing {
      kwh1000,
      kwh2000,
      kwh500
    }
  }
  providerId,
  providerName,
  providerPlanUrl,
  providerPhone,
  providerUrl,
  providerImageUrl,
  rateType,
  state,
  stateRenewablePercentage,
  termsOfServiceUrl,
  type
}`;

export const planFragment = {
  name,
  fragment,
};
